module.exports = __webpack_public_path__ + "static/media/phone_auth.d9b036bc.png";